export const WALLET_STORAGE_KEY = "wallet_info";
export const THEME_STORAGE_KEY = "theme";
